// Auto-split from i18n.js — language: es
export default {
    translation: {
        // routes & menus
        Dashboard: 'Salpicadero',
        'Space Data': 'Espacio',
        'Equipment Data': 'Equipo',
        'Meter Data': 'Metro',
        'Tenant Data': 'Arrendatario',
        'Store Data': 'Tienda',
        'Shopfloor Data': 'Taller',
        'Combined Equipment Data': 'Equipos combinados',
        'Auxiliary System': 'Sistema auxiliar',
        Microgrid: 'Microrred',
        'Energy Storage Power Station': 'Central eléctrica',
        'Photovoltaic Power Station': 'Central eléctrica',
        'Fault Alarm': 'Alarma de falla',
        Monitoring: 'Monitorización',
        'Advanced Reporting': 'Informes avanzados',
        'Knowledge Base': 'Knowledge base',
        'Energy Category Data': 'Categoría de energía',
        'Energy Item Data': 'Artículo de energía',
        Carbon: 'Emisiones de CO2',
        Cost: 'Costar',
        Output: 'Salida',
        Income: 'Renta',
        Efficiency: 'Eficacia',
        Load: 'Carga',
        Statistics: 'Estadística',
        'Batch Analysis': 'Análisis de lotes',
        Saving: 'AhorroⒺ',
        Plan: 'PlanⒺ',
        Prediction: 'PredictionⒺ',
        'Production': 'Production',
        'Space Production': 'Space Production',
        'Equipment Tracking': 'Seguimiento de equipos',
        'Equipment Comparison': 'Comparación de equipos',
        'Shopfloor Comparison': 'Comparación de equipos',
        'Store Comparison': 'Comparación de equipos',
        'Space Comparison': 'Comparación',
        'Combined Equipment Comparison': 'Comparación de equipos',
        'Tenant Comparison': 'comparar inquilinos',
        'Environment Monitor': 'Monitor de entorno',
        'Meter Energy': 'Energía del medidor',
        'Meter Prediction': 'Predicción de medidorⒺ',
        'Virtual Meter Prediction': 'Predicción de medidor virtualⒺ',
        'Offline Meter Prediction': 'Predicción de medidor sin conexiónⒺ',
        'Meter Carbon': 'Medir las Emisiones de CO2',
        'Meter Cost': 'Costo del medidor',
        'Meter Trend': 'Tendencia del medidor',
        'Meter Realtime': 'Medidor en tiempo real',
        'Meter Saving': 'Ahorro de medidoresⒺ',
        'Meter Plan': 'plano del medidorⒺ',
        'Master Meter Submeters Balance': 'Master Meter Submeters Balance',
        'Meter Batch Analysis': 'Análisis de lotes de medidores',
        'Meter Comparison': 'Comparación de medidores',
        'Meter Tracking': 'Seguimiento del medidor',
        'Virtual Meter Saving': 'Ahorro de medidores virtualesⒺ',
        'Virtual Meter Plan': 'Plan de contadores virtualesⒺ',
        'Virtual Meter Energy': 'Medidor virtual de energía',
        'Virtual Meter Carbon': 'Medidor virtual de Emisiones de CO2',
        'Virtual Meter Cost': 'Costo del medidor virtual',
        'Virtual Meter Batch Analysis': 'Análisis por lotes de medidores virtuales',
        'Virtual Meter Comparison': "Comparación de medidores virtuales",
        'Offline Meter Energy': 'Energía del medidor fuera de línea',
        'Offline Meter Carbon': 'Medición fuera de línea de Emisiones de CO2',
        'Offline Meter Cost': 'Costo del medidor fuera de línea',
        'Offline Meter Batch Analysis': 'Análisis de lotes de medidores fuera de línea',
        'Offline Meter Saving': 'Ahorro de medidores fuera de líneaⒺ',
        'Offline Meter Plan': 'Plan de medidor sin conexiónⒺ',
        'Offline Meter Input': 'Entrada de medidor fuera de línea',
        'Tenant Bill': 'Proyecto de ley del inquilino',
        'Energy Flow Diagram': 'Diagrama de flujo de energía',
        'Distribution System': 'Sistema de distribución',
        'SVG System': 'Sistema de visualización SCADA',
        'Faults Data': 'Fallas',
        'Space Equipments': 'Equipos espaciales',
        'Combined Equipments': 'Equipos combinados',
        'Energy Storage Power Station List': 'List',
        'Energy Storage Power Station Details': 'Details',
        'Energy Storage Power Station Reporting': 'Reporting',
        'Energy Storage Power Station Alarm': 'Alarm',
        'Energy Storage Power Station Maintenance': 'Maintenance',
        'Enter Production': 'Enter Production',
        'Multiple Microgrids': 'Multiple Microgirds',
        'Multiple Microgrids Dashboard': 'Dashboard',
        'Multiple Microgrids List': 'List',
        'Single Microgrid': 'Single Microgrid',
        'Single Microgrid Dashboard': 'Dashboard',
        'Single Microgrid Details': 'Details',
        'Single Microgrid Fault Alarm': 'Fault Alarm',
        'Microgrid Reports': 'Power Station Reports',
        'Microgrid Reports Energy': 'Energy',
        'Microgrid Reports Revenue': 'Revenue',
        'Microgrid Reports Parameters': 'Parameters',
        'Multiple Energy Storage Power Stations': 'Multiple Power Stations',
        'Multiple Energy Storage Power Stations Dashboard': 'Dashboard',
        'Multiple Energy Storage Power Stations List': 'List',
        'Single Energy Storage Power Station': 'Single Power Station',
        'Single Energy Storage Power Station Dashboard': 'Dashboard',
        'Single Energy Storage Power Station Details': 'Details',
        'Single Energy Storage Power Station Fault Alarm': 'Fault Alarm',
        'Energy Storage Power Station Reports': 'Power Station Reports',
        'Energy Storage Power Station Reports Energy': 'Energy',
        'Energy Storage Power Station Reports Revenue': 'Revenue',
        'Energy Storage Power Station Reports Parameters': 'Parameters',
        'Photovoltaic Power Station List': 'Power Station List',
        'Photovoltaic Power Station Details': 'Details',
        'Photovoltaic Power Station Reporting': 'Reporting',
        'Photovoltaic Power Station Alarm': 'Alarm',
        'Photovoltaic Power Station Maintenance': 'Maintenance',
        'Multiple Photovoltaic Power Stations': 'Multiple Power Stations',
        'Multiple Photovoltaic Power Stations Dashboard': 'Dashboard',
        'Multiple Photovoltaic Power Stations List': 'List',
        'Single Photovoltaic Power Station': 'Single Power Station',
        'Single Photovoltaic Power Station Dashboard': 'Dashboard',
        'Single Photovoltaic Power Station Details': 'Details',
        'Single Photovoltaic Power Station Fault Alarm': 'Fault Alarm',
        'Photovoltaic Power Station Reports': 'Power Station Reports',
        'Photovoltaic Power Station Reports Energy': 'Energy',
        'Photovoltaic Power Station Reports Revenue': 'Revenue',
        'Photovoltaic Power Station Reports Parameters': 'Parameters',
        'Work Order': 'Work Order',
        'Work Order Installation': 'Installation',
        'Work Order Repair': ' Repair',
        'Work Order Inspection': 'Inspection',
        'Total Number of Work Orders': 'Número total de órdenes de trabajo',
        'Number of New Work Orders': 'Número de órdenes de trabajo nuevas',
        'Number of Inprogress Work Orders': 'Número de órdenes de trabajo en curso',
        'Number of Done Work Orders': 'Número de órdenes de trabajo finalizadas',
        'Fuel Indicator': 'Consumo de combustible',
        'Charge Energy Indicator': 'Energía de carga',
        'Discharge Energy Indicator': 'Energía de descarga',
        'Charge Cost Indicator': 'Costo de carga',
        'Discharge Revenue Indicator': 'Ingresos de descarga',
        'HVAC': 'HVAC',
        'Fire Control': 'Control de incendios',
        'Store Dashboard': 'Panel de Tiendas',
        'Comprehensive overview of store energy performance': 'Visión general del rendimiento energético de las tiendas',
        'Total Stores': 'Total de Tiendas',
        'Total Area': 'Área Total',
        'Active Meters': 'Medidores Activos',
        'Active Alerts': 'Alertas Activas',
        'Total Energy Consumption': 'Consumo Total de Energía',
        'Carbon Emissions': 'Emisiones de Carbono',
        'Current Period': 'Período Actual',
        'Energy Consumption by Category': 'Consumo de Energía por Categoría',
        'Cost Distribution by Category': 'Distribución de Costos por Categoría',
        'Monthly Energy & Cost Trends': 'Tendencias Mensuales de Energía y Costos',
        'Top 5 Energy Consuming Stores': 'Top 5 Tiendas con Mayor Consumo',
        'Energy Category Details': 'Detalles de Categoría de Energía',
        'Store Performance Overview': 'Resumen de Rendimiento de Tiendas',
        'YoY Change': 'Cambio Interanual',
        'Per m²': 'Por m²',
        'Usage Intensity': 'Intensidad de Uso',
        'Dashboard data loaded successfully': 'Datos del panel cargados exitosamente',
        'Failed to load dashboard data': 'Error al cargar datos del panel',
        'Store Name': 'Nombre de la tienda',
        'Store Area': 'Área de la tienda',
        'Energy Consumption': 'Consumo de energía',
        'Consumption': 'Consumo',
        'last period': 'período anterior',
        // Tenant Dashboard
        'Tenant Dashboard': 'Panel de Inquilinos',
        'Comprehensive overview of tenant energy performance': 'Visión general del rendimiento energético de los inquilinos',
        'Total Tenants': 'Total de Inquilinos',
        'Tenant Performance Overview': 'Resumen de Rendimiento de Inquilinos',
        'Tenant Name': 'Nombre del Inquilino',
        'Tenant Area': 'Área del Inquilino',
        'Tenant Type': 'Tipo de Inquilino',
        // Equipment Dashboard
        'Equipment Dashboard': 'Panel de Equipos',
        'Total Equipments': 'Total de Equipos',
        'Equipment Performance Overview': 'Resumen de Rendimiento de Equipos',
        'Equipment Name': 'Nombre del Equipo',
        'Equipment Type': 'Tipo de Equipo',
        'Total Energy': 'Energía Total',
        'Total Sensors': 'Total de Sensores',
        'Increment Rate': 'Tasa de Incremento',
        // Shopfloor Dashboard
        'Total Shopfloors': 'Total de talleres',
        'Shopfloor Performance Overview': 'Resumen de rendimiento de talleres',
        'Shopfloor Name': 'Nombre del taller',
        'Shopfloor Area': 'Área del taller',
        // Combined Equipment Dashboard
        'Total Combined Equipments': 'Total de Equipos Combinados',
        'Combined Equipment Performance Overview': 'Resumen de Rendimiento de Equipos Combinados',
        'Combined Equipment Name': 'Nombre del Equipo Combinado',
        'Associated Equipments': 'Equipos Asociados',

        // Dashboard
        'Welcome to QiXuan': 'Bienvenido a QiXuan',
        'An Industry Leading Energy Management System':
            'Un sistema de gestión de energía líder en la industria',
        "This Year's Consumption CATEGORY VALUE UNIT": 'El consumo de este año {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Year's Costs CATEGORY VALUE UNIT": 'Los costos de este año {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Consumption CATEGORY VALUE UNIT": 'El consumo de este mes {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Generation CATEGORY VALUE UNIT": "This Month's Generation {{CATEGORY}} {{VALUE}} {{UNIT}}",
        "This Month's Costs CATEGORY VALUE UNIT": 'Los costos de este mes {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Consumption CATEGORY VALUE UNIT in The Same Period Last Year':
            'Consumo {{CATEGORY}} {{VALUE}} {{UNIT}}  en el mismo período del año pasado',
        'Costs CATEGORY VALUE UNIT in The Same Period Last Year':
            'Costos {{CATEGORY}} {{VALUE}} {{UNIT}} en el mismo período del año pasado',
        'CATEGORY Consumption UNIT': '{{CATEGORY}} Consumo {{UNIT}}',
        'CATEGORY Costs UNIT': '{{CATEGORY}} Costos {{UNIT}}',
        // Entities
        Space: 'Espacio',
        Equipment: 'Equipo',
        Meter: 'Metro',
        'Offline Meter': 'Medidor fuera de línea',
        'Virtual Meter': 'Medidor virtual',
        Tenant: 'Arrendatario',
        Store: 'Tienda',
        Shopfloor: 'Taller',
        'Combined Equipment': 'Equipos combinados',
        'Cost Center': 'Centro de Costos',
        Name: 'Nombre',
        DisplayName: 'Nombre para mostrar',
        UserName: 'Nombre de usuario',
        Description: 'Descripción',
        'Energy Category': 'Categoría de energía',
        'Child Spaces': 'Espacios infantiles',
        'Associated Equipment': 'Equipos asociados',
        //Energy Categories
        Electricity: 'Electricidad',
        Water: 'Agua',
        'Natural Gas': 'Gas natural',
        // SidePanelModal
        Settings: 'Configuración',
        'Set your own customized style': 'Establece tu propio estilo personalizado',
        'Color Scheme': 'Esquema de color',
        'Choose the perfect color mode for your app': 'Elige el modo de color perfecto para tu aplicación',
        Light: 'Luz',
        Dark: 'Oscuro',
        'RTL Mode': 'Modo RTL',
        'Switch your language direction': 'Cambiar la dirección del idioma',
        'Fluid Layout': 'Diseño fluido',
        'Toggle container layout system': 'Alternar sistema de diseño de contenedores',
        'Navigation Position': 'Posición de navegación',
        'Vertical': 'Vertical',
        'Top': 'Arriba',
        'Combo': 'Combinación',
        'Transparent': 'Transparente',
        'Inverted': 'Invertida',
        'Card': 'Tarjeta',
        'Vibrant': 'Vívida',
        'Select a suitable navigation system for your web application':
            'Seleccione un sistema de navegación adecuado para su aplicación web',
        'Vertical Nav': 'Navegación vertical',
        'Top Nav': 'Navegación superior',
        'Vertical Navbar Style': 'Estilo de barra de navegación vertical',
        'Switch between styles for your vertical navbar': 'Cambiar entre estilos para la barra de navegación vertical',
        Language: 'Idioma',
        'Switch between languages': 'Cambiar entre idiomas',
        'language-zh_CN': '简体中文',
        'language-en': 'English',
        'language-de': 'Deutsch',
        'language-fr': 'Français',
        'language-es': 'Español',
        'language-ru': 'Русский',
        'language-ar': 'العربية',
        'language-vi': 'Tiếng Việt',
        'language-th': 'ภาษาไทย',
        'language-tr': 'Türkçe',
        'language-ms': 'Bahasa Melayu',
        'language-id': 'Bahasa Indonesia',
        'language-zh_TW': '繁體中文',
        'language-pt': 'Português',
        'language-ko_KR': '로그아웃',
        'language-it': 'Italiano',
        'language-pol': 'Polski',
        'language-nl': 'Nederlands',
        'language-jp': '日本語',
        'language-fa': 'فارسی',
        'Like What You See?': 'Me gusta lo que ves?',
        'Get QiXuan now': 'Obtenga QiXuan ahora',
        Purchase: 'Versión corporativa',
        ContactInfo: 'Informacion de contacto',
        ProductWebsite: 'Sitio web del producto',
        CompanyWebsite: 'Sitio web de la empresa',
        SalesPhone: 'Telefono de ventas',
        // Query Panel
        'Base Period Begins': 'Comienza el período base',
        'Base Period Ends': 'Finaliza el período base',
        'Comparison Types': 'Tipos de comparación',
        'Year-Over-Year': 'Año tras año',
        'Month-On-Month': 'Mes a mes',
        'Free Comparison': 'Comparación gratuita',
        'None Comparison': 'Ninguna Comparación',
        'Reporting Period Begins': 'Comienza el período del informe',
        'Reporting Period Ends': 'Finaliza el período de presentación de informes',
        '(Optional)': '(Opcional)',
        'Period Types': 'Tipos de período',
        Yearly: 'Anual',
        Monthly: 'Mensual',
        Weekly: 'Semanal',
        Daily: 'Diario',
        Hourly: 'Cada hora',
        Submit: 'Enviar',
        'Input Energy Category': 'Categoría de energía de entrada',
        'Output Energy Category': 'Categoría de energía de salida',
        'Fraction Parameter': 'Parámetro Fraction',
        Search: 'Buscar',
        //DateRangePicker
        sunday: 'Su',
        monday: 'Mo',
        tuesday: 'Tu',
        wednesday: 'We',
        thursday: 'Th',
        friday: 'Fr',
        saturday: 'Sa',
        ok: 'De acuerdo',
        today: 'Hoy',
        yesterday: 'Ayer',
        hours: 'Horas',
        minutes: 'Acta',
        seconds: 'Sobras',
        last7Days: 'Últimos 7 días',
        tomorrow: 'Mañana',
        dayAfterTomorrow: 'Pasado mañana',
        next7Days: 'Próximos 7 días',
        'Select Date Range': 'Seleccionar intervalo de fechas',
        //Card Summaries and Line Charts
        'Base Period': 'Período base',
        'Reporting Period': 'Período',
        'Per Unit Area': 'Por unidad de área',
        'Per Capita': 'Per Capita',
        'Per Unit Production': 'Por unidad de producción',
        Baseline: 'Referencia',
        Actual: 'Actual',
        'Baseline Value - Actual Value': 'Línea base - Actual',
        'Average Load': 'Carga media',
        'Maximum Load': 'Carga máxima',
        'Load Factor': 'Factor de carga',
        'Ratio of Average Load to Maximum Load': 'Relación entre la carga media y la carga máxima',
        'Carbon Dioxide Emissions by Energy Category': 'Emisiones de dióxido de carbono por categoría de energía',
        'Costs by Energy Category': 'Costos por categoría de energía',
        'Incomes by Energy Category': 'Ingresos por categoría de energía',
        'Electricity Consumption by Time-Of-Use': 'Consumo de electricidad por tiempo de uso',
        'Electricity Carbon Dioxide Emissions by Time-Of-Use':
            'Emisiones de dióxido de carbono de electricidad por tiempo de uso',
        'Electricity Cost by Time-Of-Use': 'Costo de electricidad por tiempo de uso',
        'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} Consumo por partidas energéticas',
        'Ton of Standard Coal by Energy Category': 'Tonelada de carbón estándar(TCE) por categoría de energía',
        'Ton of Carbon Dioxide Emissions by Energy Category':
            'Toneladas de emisiones de dióxido de carbono(TCO2E) por categoría de energía',
        'Reporting Period Consumption CATEGORY UNIT': 'Consumo del período de informe {{CATEGORY}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY UNIT': 'Reporting Period Prediction {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
            '{{EQUIPMENT}} Consumo del período de informe {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} Consumo del período de informe {{CATEGORY}} {{UNIT}}',
        'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption CATEGORY VALUE UNIT': 'Consumo del período de informe {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY VALUE UNIT': 'Reporting Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Production PRODUCT VALUE UNIT': 'Reporting Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Base Period Production PRODUCT VALUE UNIT': 'Base Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption CATEGORY VALUE UNIT': 'Consumo del período base {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Prediction CATEGORY VALUE UNIT': 'Base Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY UNIT':
            'Consumo del período de informe {{ITEM}} {{CATEGORY}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY VALUE UNIT':
            'Consumo del período de informe {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption ITEM CATEGORY VALUE UNIT':
            'Consumo del período base {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Child Space Proportion CATEGORY UNIT':
            'Proporción del espacio infantil por categoría de energía {{CATEGORY}} {{UNIT}}',
        'Child Space Total Proportion': 'Espacio infantil Proporción total',
        'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT':
            'Período de presentación de informes Emisiones de dióxido de carbono {{CATEGORY}} {{UNIT}}',
        'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
            'Período de presentación de informes Emisiones de dióxido de carbono {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
            'Emisiones de dióxido de carbono del período base {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Costs CATEGORY UNIT': 'Costos del período de informe {{CATEGORY}} {{UNIT}}',
        'Reporting Period Costs CATEGORY VALUE UNIT': 'Costos del período de informe {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Costs CATEGORY VALUE UNIT': 'Costos del período base {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Output CATEGORY UNIT': 'Resultados del período del informe {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Output CATEGORY UNIT':
            '{{EQUIPMENT}} Resultados del período del informe {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} Resultados del período del informe {{CATEGORY}} {{UNIT}}',
        'Reporting Period Output CATEGORY VALUE UNIT':
            'Resultados del período del informe {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Output CATEGORY VALUE UNIT': 'Resultado del período base {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Income CATEGORY UNIT': 'Ingresos del período del informe {{CATEGORY}} {{UNIT}}',
        'Reporting Period Income CATEGORY VALUE UNIT': 'Ingresos del período del informe {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Income CATEGORY VALUE UNIT': 'Ingresos del período base {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Total Income UNIT': 'Ingresos totales del período del informe {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME UNIT':
            'Eficiencia acumulada del período de presentación de informes {{NAME}} {{UNIT}}',
        'EQUIPMENT Reporting Period Cumulative Efficiency UNIT':
            '{{EQUIPMENT}} Eficiencia acumulada del período de presentación de informes {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
            '{{COMBINED_EQUIPMENT}} Período de presentación de informes Eficiencia integral acumulada {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} Período de presentación de informes Eficiencia integral acumulada {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} Período base Eficiencia integral acumulada {{VALUE}} {{UNIT}}',
        'Instantaneous Efficiency UNIT': 'Eficiencia instantánea {{UNIT}}',
        'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} Eficiencia instantánea {{UNIT}}',
        'Equipment Efficiency Indicator': 'Indicador de eficiencia energética del equipo',
        'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT':
            '{{COMBINED_EQUIPMENT}} Eficiencia integral instantánea {{UNIT}}',
        'Reporting Period Cumulative Efficiency VALUE UNIT':
            'Eficiencia acumulada del período de presentación de informes {{VALUE}} {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME VALUE UNIT':
            'Eficiencia acumulada del período de presentación de informes {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency VALUE UNIT': 'Eficiencia acumulada del período base {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency NAME VALUE UNIT':
            'Eficiencia acumulada del período base {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period CATEGORY Maximum Load UNIT': 'Período base {{CATEGORY}} Carga máxima {{UNIT}}',
        'Reporting Period CATEGORY Maximum Load UNIT': 'Período {{CATEGORY}} Carga máxima {{UNIT}}',
        'Reporting Period CATEGORY Average Load UNIT': 'Período {{CATEGORY}} Carga media {{UNIT}}',
        'Reporting Period CATEGORY Load Factor': 'Período {{CATEGORY}} Factor de carga',
        'Base Period CATEGORY Average Load VALUE UNIT': 'Período base {{CATEGORY}} Carga media {{VALUE}} {{UNIT}}',
        'Reporting Period CATEGORY Average UNIT': 'Período {{CATEGORY}} Valor medio {{UNIT}}',
        'Reporting Period CATEGORY Maximum UNIT': 'Período {{CATEGORY}} Valor máximo {{UNIT}}',
        'Reporting Period CATEGORY Minimum UNIT': 'Período {{CATEGORY}} Valor mínimo {{UNIT}}',
        'Reporting Period CATEGORY Mean UNIT': 'Período {{CATEGORY}} Media aritmética {{UNIT}}',
        'Reporting Period CATEGORY Median UNIT': 'Período {{CATEGORY}} Mediana (Valor medio) {{UNIT}}',
        'Reporting Period CATEGORY Stdev UNIT': 'Período {{CATEGORY}} Desviación estándar de la muestra {{UNIT}}',
        'Reporting Period CATEGORY Variance UNIT': 'Período {{CATEGORY}} Varianza de la muestra {{UNIT}}',
        'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT':
            'Ahorro del período de informe {{CATEGORY}} (Línea base - Actual) {{UNIT}}',
        'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT':
            'Período de informe disminuido {{CATEGORY}} (Línea base - Actual) {{UNIT}}',
        'Reporting Period Saving CATEGORY VALUE UNIT': 'Ahorro del período de informe {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Saving CATEGORY VALUE UNIT': 'Ahorro del período base {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY UNIT':
            'Período de informe Consumo del medidor maestro {{CATEGORY}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT':
            'Período de informe Consumo del medidor maestro {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY UNIT':
            'Período del informe Consumo de submedidores {{CATEGORY}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY VALUE UNIT':
            'Período del informe Consumo de submedidores {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Difference CATEGORY UNIT': 'Diferencia en el período del informe {{CATEGORY}} {{UNIT}}',
        'Reporting Period Percentage Difference': 'Diferencia porcentual del período del informe',
        'Reporting Period Difference CATEGORY VALUE UNIT':
            'Diferencia en el período del informe {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        //FDD
        'Fault List': 'Lista de fallos',
        'Reporting Period Number of Fault VALUE': 'Período de informe Número de falla {{VALUE}}',
        'All Faults': 'Todas las fallas',
        'Space Faults': 'Fallas de espacio',
        'Number of All Faults': 'Número de todas las fallas',
        'Number of Space Faults': 'Número de fallos de espacio',
        'Total Number of Faults': 'Total Number of Faults',
        'Number of New Faults': 'Number of New Faults',
        'Number of Inprogress Faults': 'Number of Inprogress Faults',
        'Number of Done Faults': 'Number of Done Faults',
        //Data Panels
        'Ton of Standard Coal': 'Tonelada de carbón estándar',
        'Ton of Carbon Dioxide Emissions': 'Toneladas de emisiones de dióxido de carbono',
        'Carbon Emissions Per Unit Of Energy Consumption': 'Emisiones de carbono por unidad de consumo de energía',
        'Operating Characteristic Curve': 'Curva característica de trabajo',
        Tariff: 'Arancel',
        'Detailed Data': 'Datos detallados',
        'Child Spaces Data': 'Datos de espacios secundarios',
        'Associated Equipment Data': 'Datos de equipos asociados',
        'This Year': 'Este año',
        'The Same Period Last Year': 'El mismo período del año pasado',
        'This Month': 'Este mes',
        'This Day': 'Este día',
        Total: 'Total',
        'No data found': 'No se han encontrado datos',
        Export: 'Exportar',
        'AI Analysis': 'Análisis por IA',
        Datetime: 'Fecha y hora',
        'Time-Of-Use Type': 'Tipo de tiempo de uso',
        'Top-Peak': 'Pico superior',
        'On-Peak': 'En horas pico',
        'Mid-Peak': 'Pico medio',
        'Off-Peak': 'Fuera de las horas pico',
        'Deep': 'Deep-Valley',
        Percentage: 'Porcentaje',
        //Realtime Chart
        'Trend in the last hour of Energy Value Point': 'Tendencia en la última hora de Energy Value Point',
        Circuit: 'Circuito',
        Point: 'Punto',
        'Realtime Value': 'Valor en tiempo real',
        //Meter Tracking
        'Meter List': 'Lista de medidores',
        'Edit Meter': 'Editar',
        'Start Value': 'Valor inicial',
        'End Value': 'Valor final',
        'Difference Value': 'Valor de diferencia',
        'Start Integrity Rate': 'Tasa de integridad de inicio(%)',
        'End Integrity Rate': 'Tasa de integridad final(%)',
        'Full Integrity Rate': 'Tasa de integridad total(%)',
        'Start Integrity Rate Description': 'Tasa de Integridad de Datos Inicial: Proporción de medidores que obtuvieron con éxito lecturas de consumo de energía en el momento de inicio entre todos los medidores durante el período estadístico',
        'End Integrity Rate Description': 'Tasa de Integridad de Datos Final: Proporción de medidores que obtuvieron con éxito lecturas de consumo de energía en el momento de finalización entre todos los medidores durante el período estadístico',
        'Full Integrity Rate Description': 'Tasa de Integridad de Datos Completa: Proporción de medidores que obtuvieron con éxito lecturas de consumo de energía tanto en el momento de inicio como en el de finalización entre todos los medidores durante el período estadístico',
        //Equipment Tracking
        'Equipment List': 'Lista de equipos',
        'Edit Equipment': 'Editar',
        //Profile Dropdown
        Feedback: 'Retroalimentación',
        'Account Settings': 'Configuración de la cuenta',
        Logout: 'Cerrar sesión',
        //Authentication
        'Log in': 'Inicia sesión',
        'Email address': 'Dirección de correo electrónico',
        'Phone Number': 'Número de teléfono',
        Password: 'Contraseña',
        CaptchaCode: 'Captcha',
        Refresh: 'Actualizar',
        'Remember me': 'Recuérdame',
        'Logged in as ': 'Conectado como ',
        'Forgot Password?': 'Olvidé mi contraseña?',
        'Forgot your password?': 'Olvidó su contraseña?',
        "Enter your email and we'll send you a reset link":
            'Introduce tu correo electrónico y te enviaremos un enlace de restablecimiento',
        "Enter your email and we'll send you a registration link":
            'Introduce tu email y te enviaremos un enlace de registro',
        'Reset Password': 'Restablecer contraseña',
        'Thanks for using QiXuan!': 'Gracias por usar QiXuan!',
        'You are now successfully signed out': 'Ahora ha cerrado sesión correctamente',
        'Return to Login': 'Volver al inicio de sesión',
        'Please check your email!': 'Por favor, revise su correo electrónico!',
        'An email has been sent to ': 'Se ha enviado un correo electrónico a ',
        'Please click on the included link to reset your password':
            'Haga clic en el enlace incluido para restablecer su contraseña',
        'Please click on the included link to register your account':
            'Haga clic en el enlace incluido para registrar su cuenta',
        'An email with password reset link is sent to ':
            'Se envía un correo electrónico con el enlace de restablecimiento de contraseña a ',
        'Change Password': 'Cambiar contraseña',
        'Old Password': 'Contraseña antigua',
        'New Password': 'Nueva contraseña',
        'Confirm Password': 'Confirmar contraseña',
        'Update Password': 'Actualizar contraseña',
        'Password has been changed!': 'Se ha cambiado la contraseña!',
        'Verification code has been sent to your inbox. \
  Please copy it to the input box below..':
            'Se ha enviado un código de verificación a tu bandeja de entrada. \
  Cópielo en el cuadro de entrada a continuación.',
        'New to QiXuan': 'Nuevo en QiXuan',
        'Create an account': 'Crear una cuenta',
        'EMAIL Account registration successful': '{{EMAIL}} Registro de cuenta exitoso',
        'Thanks for verifying your account!': 'Gracias por verificar tu cuenta!',
        'Your code is': 'Su código es',
        'Send verification code': 'Enviar código de verificación',
        'Please wait for NUMBER seconds': 'Por favor, espere a {{NUMBER}} sobras',
        'Password reset': 'Restablecimiento de contraseña',
        'Please wait for approval': 'Por favor, espere la aprobación',
        //notification
        Notifications: 'Notificaciones',
        'Mark all as read': 'Marcar todo como leído',
        'View all': 'Todo',
        'Notification New': 'NUEVO',
        'Notification Earlier': 'ANTERIOR',
        'Notification List': 'Lista de notificaciones',
        'Bulk actions': 'Acciones masivas',
        'Notification Subject': 'Asunto',
        'Notification Created Datetime': 'Fecha y hora de creación',
        'Notification Priority': 'Prioridad',
        'Notification Message': 'Mensaje',
        'Notification Status': 'Estado',
        'Notification Mark As Read': 'Marcar como leído',
        'Notification Mark As Acknowledged': 'Reconocer',
        'Notification Low': 'Bajo',
        'Notification Medium': 'Medio',
        'Notification High': 'Alto',
        'Notification Critical': 'Crítico',
        'Notification Unread': 'No leído',
        'Notification Read': 'Leer',
        'Notification Acknowledged': 'Reconocido',
        'Notification Archive': 'Archivo',
        'Notification Delete': 'Borrar',
        'Notification Apply': 'Aplicar',
        'Notification Start Datetime': 'Fecha de inicio y hora',
        'Notification End Datetime': 'Fecha y hora de finalización',
        'Notification Update Datetime': 'Actualizar fecha y hora',
        //Monitoring
        'Run Commands': 'Ejecutar comandos',
        'Pin Code': 'Código PIN',
        'Unlock': 'Descubrir',
        'Set Value': 'Establecer valor',
        'Fault Alarms': 'Alarmas de avería',
        'Instantaneous Efficiency VALUE UNIT': 'Eficiencia instantánea {{VALUE}} {{UNIT}}',
        'Communication Online': 'En línea',
        'Communication Offline': 'Sin conexión',
        'Equipment Status': 'Estado del dispositivo',
        'Equipment Running': 'Corriente',
        'Equipment Stopped': 'Detenido',
        'Show Up to': 'Presentarse a',
        All: 'Todo',
        'FROM - TO of TOTAL': 'Actualmente se muestra {{FROM}} - {{TO}} total {{TOTAL}}',
        //Microgrid
        'Microgrid Energy': 'Energía de microrredes',
        'Microgrid Revenue': 'Ingresos de microrredes',
        'Microgrid Carbon': 'Carbono de microrredes',
        'Photovoltaic Generation': 'Generación fotovoltaica',
        'EV Charger Consumption': 'Consumo de cargadores EV',
        'Load Consumption': 'Consumo de carga',
        'Grid Buy': 'Compra de la red',
        'Grid Sell': 'Venta a la red',
        'EV Charger': 'Cargador de vehículos eléctricos',
        'Heat Pump': 'Bomba de calor',
        'Photovoltaic': 'Fotovoltaica',
        'PCS Run State': 'Estado de funcionamiento del PCs',
        'PCS Unknown': 'Desconocido',
        'PCS Initializing': 'Se está iniciando',
        'PCS Standby': 'Artículos de repuesto',
        'PCS Shutdown': 'Parada',
        'PCS Fault': 'Culpa',
        'PCS Running': 'Correr',
        'Battery Power': 'Potencia de la batería',
        'Photovoltaic Power': 'Фотоэлектрическая мощность',
        'Grid Power': 'Potencia de la red eléctrica',
        'Load Power': 'Potencia de carga',
        Reporting: 'Informe',
        Maintenance: 'Mantenimiento',
        'Serial Number': 'Numéro de série',
        Address: 'Adresse de résidence',
        'Postal Code': 'Code Postal',
        'Rated Capacity': 'Capacidad nominal',
        'Rated Power': 'Potencia nominal',
        Latitude: 'Latitude',
        Longitude: 'Longitude',
        'Strategy Management': 'Gestión estratégica',
        'Charging Schedule': 'Calendrier de charge',
        'Charge Start Time': 'Heure de début de charge',
        'Charge End Time': 'Temps de fin de charge',
        'Discharge Start Time': 'Heure de début de décharge',
        'Discharge End Time': 'Temps de fin de décharge',
        'Total Rated Power': 'Potencia nominal total',
        'Total Rated Capacity': 'Capacidad nominal total',
        "Today's Charge": "Carga hoy",
        "Today's Discharge": "Descarga de electricidad hoy",
        "Today's Generation": "La generación de energía actual",
        'Total Fuel Consumption': 'Total Fuel Consumption',
        'Total Charge': 'Carga total',
        'Total Discharge': 'descarga total',
        'Total Generation': 'Generación total',
        'Total Revenue': 'Los ingresos totales',
        'Total Photovoltaic Generation': 'Generación fotovoltaica total',
        'Total EV Charger Consumption': 'Consumo total de cargadores EV',
        'Total Load Consumption': 'Consumo total de carga',
        'Total Grid Buy': 'Compra total de la red',
        'Total Grid Sell': 'Venta total a la red',
        'Total Efficiency': 'Eficiencia total',
        'Discharge Achievement Rate': 'Tasa de logro de descarga',
        // Revenue Indicator
        "Today's Cost": "Today's Cost",
        "Today's Income": "Today's Income",
        "Total Cost": "Total Cost",
        "Total Income": "Total Income",
        "Today's Revenue": "Today's Revenue",

        'Revenue Ranking': 'Clasificación de ingresos',
        'Efficiency Ranking': 'Clasificación de eficiencia',
        'Charge Ranking': 'Clasificación de capacidad de carga',
        'Discharge Ranking': 'Clasificación de alta',
        'Number of Microgrids': 'Número de microrredes',
        'Number of Power Stations': 'Número de centrales eléctricas',
        'Microgrid List': 'Lista de microrredes',
        'Select Microgrid': 'Seleccionar microrred',
        'Previous Page': 'Pagina anterior',
        'Next Page': 'Siguiente página',
        '7 Days': '7 días',
        'Charge UNIT': 'Cargar {{UNIT}}',
        'Discharge UNIT': 'descargar {{UNIT}}',
        'Generation UNIT': 'producir electricidad {{UNIT}}',
        'Energy Indicator': 'energía',
        'Revenue Indicator': 'rendimiento',
        'Carbon Indicator': 'carbono',

        // Energy Storage Power Station
        'Battery Operating State': 'Estado de funcionamiento de la batería',
        'Battery State': 'Estado de la batería',
        'Battery Unknown': 'Desconocido',
        'Battery Stopped': 'Se ha detenido',
        'Battery Reserved': 'Reserved', // 0
        'Battery Fault': 'Culpa', // 1
        'Battery Warning': 'Aviso', // 2
        'Battery Standby': 'Artículos de repuesto', // 3
        'Battery Prohibit DisCharging': 'Prohibición de descargar', // 4
        'Battery Prohibit Charging': 'Está prohibido cargar', // 5
        'Battery Normal': 'Típico', // 6
        'Battery Charging': 'En carga', // 7
        'Battery Discharging': 'En descarga', // 8
        'Battery Idle': 'Idle', // 9
        'Phase of Lifecycle': 'Fase del ciclo de vida',
        'Use Phase': 'Fase de uso',
        'Commissioning Phase': 'Fase de puesta en marcha',
        'Commissioning Date': 'Commissioning Date',
        'Installation Phase': 'Fase de instalación',
        'Device Status': 'Estado del dispositivo',
        'Basic Information': 'Información básica',
        'Gateway': 'Gateway',
        'Grid Meter': 'Grid Meter',
        'Load Meter': 'Load Meter',
        'ESS Meter': 'ESS Meter',
        'Total Active Power': 'Total Active Power',
        'Active Power A': 'Active Power A',
        'Active Power B': 'Active Power B',
        'Active Power C': 'Active Power C',
        'Total Reactive Power': 'Total Reactive Power',
        'Reactive Power A': 'Reactive Power A',
        'Reactive Power B': 'Reactive Power B',
        'Reactive Power C': 'Reactive Power C',
        'Total Apparent Power': 'Total Apparent Power',
        'Apparent Power A': 'Apparent Power A',
        'Apparent Power B': 'Apparent Power B',
        'Apparent Power C': 'Apparent Power C',
        'Total Power Factor': 'Total Power Factor',
        'Active Energy Import': 'Active Energy Import',
        'Active Energy Export': 'Active Energy Export',
        'Active Energy Net': 'Active Energy Net',

        'Generator': 'Generator',

        // Photovoltaic Power Station
        'Invertor': 'inversores',
        'Invertor Run State': 'Estado de funcionamiento',
        'Invertor Unknown': 'Desconocido',
        'Invertor Initializing': 'Se está iniciando',
        'Invertor Standby': 'Artículos de repuesto',
        'Invertor Shutdown': 'Parada',
        'Invertor Fault': 'Culpa',
        'Invertor Running': 'Correr',

        //Advanced Reporting & Knowledge base
        'Created Datetime': 'Fecha y hora creada',
        'File Format': 'Formato de archivo',
        'File Size': 'Tamaño del archivo',
        Uploader: 'Cargador',
        //Error
        "The page you're looking for is not found": 'La página que estás buscando no se encuentra',
        "Make sure the address is correct and that the page hasn't moved. ":
            'Asegúrese de que la dirección sea correcta y que la página no se haya movido. ',
        'If you think this is a mistake,': 'Si crees que esto es un error,',
        'contact us': 'contáctenos',
        'Take me home': 'Llévame a casa',
        'Whoops, something went wrong!': 'Vaya, algo salió mal!',
        'Try refreshing the page, or going back and attempting the action again. ':
            'Intente actualizar la página o retroceda e intente la acción nuevamente. ',
        'If this problem persists,': 'Si este problema persiste,',
        'Captcha Error': 'Error de captcha',
        'Confirm Password Error': 'La contraseña de confirmación no coincide',
        'It looks like you clicked on an invalid password reset link. Please tryagain.':
            'Parece que hiciste clic \
  en un vínculo de restablecimiento de contraseña no válido. Inténtalo de nuevo.',
        'It looks like you clicked on an invalid registration account link. Please tryagain.':
            'Parece que hiciste clic \
  en un vínculo de cuenta de registro no válido. Inténtalo de nuevo.',
        //Tenant Bill
        'Lease Contract Number': 'Número de contrato de arrendamiento',
        Download: 'Descargar',
        Print: 'Impresión',
        'Payment Notice': 'Aviso de pago',
        'Bill To': 'Facturar a',
        'Bill Number': 'Número de factura',
        'Bill Date': 'Fecha de facturación',
        'Payment Due Date': 'Fecha de vencimiento del pago',
        'Amount Payable': 'Importe a pagar',
        'Billing Period Start': 'Inicio del período de facturación',
        'Billing Period End': 'Fin del período de facturación',
        Quantity: 'Cantidad',
        Price: 'Precio',
        Amount: 'Importe',
        Subtotal: 'Subtotal',
        'VAT Output Tax': 'IVA repercutido',
        'Total Amount Payable': 'Importe total a pagar',
        'Please make sure to pay on or before the payment due date above':
            'Asegúrese de pagar en o antes de la fecha de vencimiento del pago anterior',
        'Send money to the following account': 'Enviar dinero a la siguiente cuenta',
        'Account Name': 'Nombre de la cuenta',
        'Bank Name': 'Nombre del banco',
        'Bank Address': 'Dirección del banco',
        'RMB Account': 'Cuenta en RMB',
        // button
        'Toggle Navigation': 'Alternar navegación',
        // working calendar
        'Working Days': 'Días laborables',
        'Non Working Days': 'Días no laborables',
        'Select Row': 'Seleccione Fila de datos',
        // Offline Meter Input
        'Daily Value': 'Valor diario',
        Date: 'Fecha',
        'Successfully Saved': 'Guardado correctamente',
        'Previous Data Is Empty': 'Los datos anteriores están vacíos',
        // API
        'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
        'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Administrator session not found',
        'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Administrator session timeout',
        'API.ADVANCED_REPORT_NOT_FOUND': 'Advanced report not found',
        'API.API_KEY_HAS_EXPIRED': 'Key has expired',
        'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
        'API.API_KEY_NOT_FOUND': 'Key not found',
        'API.BAD_REQUEST': 'Bad request',
        'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
        'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
        'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
        'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Cannot set existing submeter as master meter',
        'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Combined equipment equipment relation exists',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Combined equipment equipment relation not found',
        'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Combined equipment meter relation exists',
        'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Combined equipment meter relation not found',
        'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Combined equipment name is already in use',
        'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Combined equipment not found',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Combined equipment offline meter relation exists',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Combined equipment offline meter relation not found',
        'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Combined equipment parameter name is already in use',
        'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Combined equipment parameter not found or not match',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Combined equipment virtual meter relation exists',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Combined equipment virtual meter relation not found',
        'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
        'API.COMMAND_NOT_FOUND': 'Command not  found',
        'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Contact name is already in use',
        'API.CONTACT_NOT_FOUND': 'Contact not found',
        'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
        'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'Cost center external id exists',
        'API.COST_CENTER_NAME_EXISTS': 'Cost center name exists',
        'API.COST_CENTER_NOT_FOUND': 'Cost center not found',
        'API.COST_FILE_NOT_FOUND': 'Cost file not found',
        'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
        'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Data source name is already in use',
        'API.DATA_SOURCE_NOT_FOUND': 'Data source not found',
        'API.DATABASE_ERROR': 'Database error',
        'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Date Is Already In Working Calendar',
        'API.DATE_LOCAL_NOT_FOUND': 'Date local not found',
        'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
        'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Distribution circuit name is already in use',
        'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Distribution circuit not found',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Distribution circuit point relation exists',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Distribution circuit point relation not found',
        'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Distribution system name is already in use',
        'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Distribution system not found',
        'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
        'API.EMAIL_IS_ALREADY_IN_USE': 'Email is already in use',
        'API.EMAIL_MESSAGE_NOT_FOUND': 'Email message not found',
        'API.EMAIL_NOT_FOUND': 'Email not found',
        'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'Email server host is already in use',
        'API.EMAIL_SERVER_NOT_FOUND': 'Email server not found',
        'API.EMPTY_VARIABLES_ARRAY': 'Empty variables array',
        'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Energy category name is already in use',
        'API.ENERGY_CATEGORY_NOT_FOUND': 'Energy category not found',
        'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Energy category used in energy items',
        'API.ENERGY_CATEGORY_USED_IN_METER': 'Energy category used in meter',
        'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Energy category used in offline meter',
        'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Energy category used in tariffs',
        'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Energy category used in virtual meter',
        'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Energy flow diagram link is already in use',
        'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram link not found or not match',
        'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram name is already in use',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram node name is already in use',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram node not found or not match',
        'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Energy flow diagram not found',
        'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item does not belong to energy category',
        'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item is not belong to energy category',
        'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Energy item name is already in use',
        'API.ENERGY_ITEM_NOT_FOUND': 'Energy item not found',
        'API.ENERGY_ITEM_USED_IN_METER': 'Energy item used in meter',
        'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Energy item used in offline meter',
        'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Energy item used in virtual meter',
        'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
        'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
        'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
        'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
        'API.EQUIPMENT_METER_RELATION_EXISTS': 'Equipment meter relation exists',
        'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Equipment meter relation not found',
        'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Equipment name is already in use',
        'API.EQUIPMENT_NOT_FOUND': 'Equipment not found',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Equipment offline meter relation exists',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Equipment offline meter relation not found',
        'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Equipment parameter name is already in use',
        'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Equipment parameter not found or not match',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Equipment virtual meter relation exists',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Equipment virtual meter relation not found',
        'API.ERROR': 'Error',
        'API.EXCEPTION': 'Exception',
        'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
        'API.FAILED_TO_RESTORE_COST_FILE': 'Failed to restore cost file',
        'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
        'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Failed to restore knowledge file',
        'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Failed to restore offline meter file',
        'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Failed to save offline meter file',
        'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
        'API.FAILED_TO_UPLOAD_COST_FILE': 'Failed to upload cost file',
        'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
        'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Failed to upload knowledge file',
        'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Failed to upload offline meter file',
        'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Gateway name is already in use',
        'API.GATEWAY_NOT_FOUND': 'Gateway not found',
        'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
        'API.INVALID_': 'Invalid ',
        'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
        'API.INVALID_ADDRESS': 'Invalid address',
        'API.INVALID_ADDRESS_VALUE': 'Invalid address value',
        'API.INVALID_ADVANCED_REPORT_ID': 'Invalid advanced report id',
        'API.INVALID_API_KEY_ID': 'Invalid api key id',
        'API.INVALID_API_KEY_NAME': 'Invalid api key name',
        'API.INVALID_AREA_VALUE': 'Invalid area value',
        'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
        'API.INVALID_BASE_PERIOD_END_DATETIME': 'Invalid base period end datetime',
        'API.INVALID_BASE_PERIOD_START_DATETIME': 'Invalid base period start datetime',
        'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
        'API.INVALID_BAUD_RATE': 'Invalid baud rate',
        'API.INVALID_BUILDINGS_VALUE': 'Invalid buildings value',
        'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
        'API.INVALID_CAPACITY': 'Invalid capacity',
        'API.INVALID_CATEGORY': 'Invalid category',
        'API.INVALID_CHANNEL': 'Invalid channel',
        'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
        'API.INVALID_COMBINED_EQUIPMENT_ID': 'Invalid combined equipment id',
        'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Invalid combined equipment name',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'Invalid combined equipment parameter id',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Invalid combined equipment parameter name',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Invalid combined equipment parameter type',
        'API.INVALID_COMBINED_EQUIPMENT_UUID': 'Invalid combined equipment uuid',
        'API.INVALID_COMMAND_ID': 'Invalid command id',
        'API.INVALID_COMMAND_NAME': 'Invalid command name',
        'API.INVALID_CONNECTION': 'Invalid connection',
        'API.INVALID_CONSTANT_VALUE': 'Invalid constant value',
        'API.INVALID_CONTACT_ID': 'Invalid contact id',
        'API.INVALID_CONTACT_NAME': 'Invalid contact name',
        'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
        'API.INVALID_COST_CENTER_ID': 'Invalid cost center id',
        'API.INVALID_COST_FILE_ID': 'Invalid cost file id',
        'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
        'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
        'API.INVALID_DATA_SOURCE_ID': 'Invalid data source id',
        'API.INVALID_DATA_SOURCE_NAME': 'Invalid data source name',
        'API.INVALID_DATA_SOURCE_PROTOCOL': 'Invalid data source protocol',
        'API.INVALID_DATE_LOCAL': 'Invalid date local',
        'API.INVALID_DENOMINATOR_METER_UUID': 'Invalid denominator meter uuid',
        'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
        'API.INVALID_DISPLAY_NAME': 'Invalid display name',
        'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'Invalid distribution circuit id',
        'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Invalid distribution circuit name',
        'API.INVALID_DISTRIBUTION_ROOM': 'Invalid distribution room',
        'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'Invalid distribution system id',
        'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Invalid distribution system name',
        'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
        'API.INVALID_EMAIL': 'Invalid email',
        'API.INVALID_EMAIL_MESSAGE_ID': 'Invalid email message id',
        'API.INVALID_EMAIL_SERVER_HOST': 'Invalid email server host',
        'API.INVALID_EMAIL_SERVER_ID': 'Invalid email server id',
        'API.INVALID_END_DATE_FORMAT': 'Invalid end date format',
        'API.INVALID_END_DATETIME': 'Invalid end datetime',
        'API.INVALID_ENERGY_CATEGORY_ID': 'Invalid energy category id',
        'API.INVALID_ENERGY_CATEGORY_NAME': 'Invalid energy category name',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'Invalid energy flow diagram id',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'Invalid energy flow diagram link id',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Invalid energy flow diagram name',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'Invalid energy flow diagram node id',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Invalid energy flow diagram node name',
        'API.INVALID_ENERGY_ITEM_ID': 'Invalid energy item id',
        'API.INVALID_ENERGY_ITEM_NAME': 'Invalid energy item name',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
        'API.INVALID_EQUATION_IN_EXPRESSION': 'Invalid equation in expression',
        'API.INVALID_EQUIPMENT_ID': 'Invalid equipment id',
        'API.INVALID_EQUIPMENT_NAME': 'Invalid equipment name',
        'API.INVALID_EQUIPMENT_PARAMETER_ID': 'Invalid equipment parameter id',
        'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Invalid equipment parameter name',
        'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Invalid equipment parameter type',
        'API.INVALID_EQUIPMENT_UUID': 'Invalid equipment uuid',
        'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
        'API.INVALID_EXPRESSION': 'Invalid expression',
        'API.INVALID_EXPRESSION_OBJECT': 'Invalid expression object',
        'API.INVALID_FDD_CODE': 'Invalid fdd code',
        'API.INVALID_FLOORS_VALUE': 'Invalid floors value',
        'API.INVALID_FROM_ADDR': 'Invalid from addr',
        'API.INVALID_GATEWAY_ID': 'Invalid gateway id',
        'API.INVALID_GATEWAY_NAME': 'Invalid gateway name',
        'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
        'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
        'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Invalid hourly high limit value',
        'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Invalid hourly low limit value',
        'API.INVALID_Id': 'Invalid id',
        'API.INVALID_IS_ADMIN_VALUE': 'Invalid is admin value',
        'API.INVALID_IS_COST_DATA_DISPLAYED': 'Invalid is cost data displayed',
        'API.INVALID_IS_COUNTED_VALUE': 'Invalid is counted value',
        'API.INVALID_IS_ENABLED': 'Invalid is enabled',
        'API.INVALID_IS_HIDDEN': 'Invalid is hidden',
        'API.INVALID_IS_IN_LEASE_VALUE': 'Invalid is in lease value',
        'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Invalid is input counted value',
        'API.INVALID_IS_KEY_TENANT_VALUE': 'Invalid is key tenant value',
        'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Invalid is output counted value',
        'API.INVALID_IS_OUTPUT_VALUE': 'Invalid is output value',
        'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
        'API.INVALID_IS_TREND_VALUE': 'Invalid is trend value',
        'API.INVALID_IS_VIRTUAL_VALUE': 'Invalid is virtual value',
        'API.INVALID_KGCE': 'Invalid kgce',
        'API.INVALID_KGCO2E': 'Invalid kgco2e',
        'API.INVALID_KNOWLEDGE_FILE_ID': 'Invalid knowledge file id',
        'API.INVALID_LATITUDE_VALUE': 'Invalid latitude value',
        'API.INVALID_LEASE_NUMBER_VALUE': 'Invalid lease number value',
        'API.INVALID_LONGITUDE_VALUE': 'Invalid longitude value',
        'API.INVALID_LOW_LIMIT_VALUE': 'Invalid low limit value',
        'API.INVALID_MASTER_METER_ID': 'Invalid master meter id',
        'API.INVALID_MENU_ID': 'Invalid menu id',
        'API.INVALID_MESSAGE_DATA': 'Invalid message data',
        'API.INVALID_MESSAGE_TEMPLATE': 'Invalid message template',
        'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
        'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
        'API.INVALID_METER_ID': 'Invalid meter id',
        'API.INVALID_METER_NAME': 'Invalid meter name',
        'API.INVALID_METER_UUID': 'Invalid meter uuid',
        'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
        'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
        'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
        'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
        'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
        'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
        'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
        'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
        'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
        'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
        'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
        'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
        'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
        'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic id',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
        'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
        'API.INVALID_NAME_VALUE': 'Invalid name value',
        'API.INVALID_NEW_PASSWORD': 'Invalid new password',
        'API.INVALID_NON_WORKING_DAY_ID': 'Invalid non working day ID',
        'API.INVALID_NOTIFICATION_ID': 'Invalid notification id',
        'API.INVALID_NUMERATOR_METER_UUID': 'Invalid numerator meter uuid',
        'API.INVALID_OBJECT_TYPE': 'Invalid object type',
        'API.INVALID_OFFLINE_METER_DATA': 'Invalid offline meter data',
        'API.INVALID_OFFLINE_METER_FILE_ID': 'Invalid offline meter file id',
        'API.INVALID_OFFLINE_METER_ID': 'Invalid offline meter id',
        'API.INVALID_OFFLINE_METER_NAME': 'Invalid offline meter name',
        'API.INVALID_OFFLINE_METER_UUID': 'Invalid offline meter uuid',
        'API.INVALID_OFFSET_CONSTANT_VALUE': 'Invalid offset constant value',
        'API.INVALID_OLD_PASSWORD': 'Invalid old password',
        'API.INVALID_OPENID': 'Invalid openid',
        'API.INVALID_PARENT_SPACE_ID': 'Invalid parent space id',
        'API.INVALID_PASSWORD': 'Invalid password',
        'API.INVALID_PAYLOAD': 'Invalid payload',
        'API.INVALID_PEAK_CURRENT': 'Invalid peak current',
        'API.INVALID_PEAK_LOAD': 'Invalid peak load',
        'API.INVALID_PERIOD_TYPE': 'Invalid period type',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
        'API.INVALID_POINT_ID': 'Invalid point id',
        'API.INVALID_POINT_NAME': 'Invalid point name',
        'API.INVALID_PORT': 'Invalid port',
        'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
        'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
        'API.INVALID_PRIORITY': 'Invalid priority',
        'API.INVALID_PRIVILEGE': 'Invalid privilege',
        'API.INVALID_PRIVILEGE_DATA': 'Invalid privilege data',
        'API.INVALID_PRIVILEGE_ID': 'Invalid privilege id',
        'API.INVALID_PRIVILEGE_NAME': 'Invalid privilege name',
        'API.INVALID_RATIO_VALUE': 'Invalid ratio value',
        'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
        'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
        'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
        'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
        'API.INVALID_REPLY': 'Invalid reply',
        'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Invalid reporting period end datetime',
        'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Invalid reporting period start datetime',
        'API.INVALID_REQUIRES_AUTHENTICATION': 'Invalid requires authentication',
        'API.INVALID_ROOMS_VALUE': 'Invalid rooms value',
        'API.INVALID_RULE_ID': 'Invalid rule id',
        'API.INVALID_RULE_NAME': 'Invalid rule name',
        'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
        'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
        'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
        'API.INVALID_SENSOR_ID': 'Invalid sensor id',
        'API.INVALID_SENSOR_NAME': 'Invalid sensor name',
        'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
        'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
        'API.INVALID_SERIAL_PORT': 'Invalid serial port',
        'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Invalid session please re-login',
        'API.INVALID_SET_VALUE': 'Invalid set value',
        'API.INVALID_SHOPFLOOR_ID': 'Invalid shopfloor id',
        'API.INVALID_SHOPFLOOR_NAME': 'Invalid shopfloor name',
        'API.INVALID_SHOPFLOOR_UUID': 'Invalid shopfloor uuid',
        'API.INVALID_SOURCE_NODE_ID': 'Invalid source node id',
        'API.INVALID_SPACE_ID': 'Invalid space id',
        'API.INVALID_SPACE_NAME': 'Invalid space name',
        'API.INVALID_SPACE_UUID': 'Invalid space uuid',
        'API.INVALID_START_DATE_FORMAT': 'Invalid start date format',
        'API.INVALID_START_DATETIME': 'Invalid start datetime',
        'API.INVALID_STATUS': 'Invalid status',
        'API.INVALID_STORE_ID': 'Invalid store id',
        'API.INVALID_STORE_NAME': 'Invalid store name',
        'API.INVALID_STORE_TYPE_DESCRIPTION': 'Invalid store type description',
        'API.INVALID_STORE_TYPE_ID': 'Invalid store type id',
        'API.INVALID_STORE_TYPE_NAME': 'Invalid store type name',
        'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Invalid store type simplified code',
        'API.INVALID_STORE_UUID': 'Invalid store uuid',
        'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
        'API.INVALID_SVG': 'Invalid SVG',
        'API.INVALID_SWITCHGEAR': 'Invalid switchgear',
        'API.INVALID_TARGET_NODE_ID': 'Invalid target node id',
        'API.INVALID_TARIFF_BLOCK_PRICING': 'Invalid tariff block pricing',
        'API.INVALID_TARIFF_ID': 'Invalid tariff id',
        'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Invalid tariff time of use pricing',
        'API.INVALID_TARIFF_TYPE': 'Invalid tariff type',
        'API.INVALID_TENANT_ID': 'Invalid tenant id',
        'API.INVALID_TENANT_NAME': 'Invalid tenant name',
        'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Invalid tenant type description',
        'API.INVALID_TENANT_TYPE_ID': 'Invalid tenant type id',
        'API.INVALID_TENANT_TYPE_NAME': 'Invalid tenant type name',
        'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Invalid tenant type simplified code',
        'API.INVALID_TENANT_UUID': 'Invalid tenant uuid',
        'API.INVALID_TEXT_MESSAGE_ID': 'Invalid text message id',
        'API.INVALID_TIMEZONE_ID': 'Invalid timezone id',
        'API.INVALID_TOKEN': 'Invalid token',
        'API.INVALID_TOPIC': 'Invalid topic',
        'API.INVALID_UNIT_OF_MEASURE': 'Invalid unit of measure',
        'API.INVALID_UNIT_OF_PRICE': 'Invalid unit of price',
        'API.INVALID_UNITS': 'Invalid units',
        'API.INVALID_USER_ID': 'Invalid user id',
        'API.INVALID_USER_NAME': 'Invalid user name',
        'API.INVALID_USER_NAME_OR_EMAIL': 'Invalid user name or email',
        'API.INVALID_USER_PHONE': 'Invalid user phone',
        'API.INVALID_USER_PLEASE_RE_LOGIN': 'Invalid user please re-login',
        'API.INVALID_USER_UUID': 'Invalid user uuid',
        'API.INVALID_USERNAME': 'Invalid userName',
        'API.INVALID_VARIABLE_METER_ID': 'Invalid variable meter id',
        'API.INVALID_VARIABLE_METER_TYPE': 'Invalid variable meter type',
        'API.INVALID_VARIABLE_NAME': 'Invalid variable name',
        'API.INVALID_VERIFICATION_CODE': 'Invalid verification code',
        'API.INVALID_VIRTUAL_METER_ID': 'Invalid virtual meter id',
        'API.INVALID_VIRTUAL_METER_NAME': 'Invalid virtual meter name',
        'API.INVALID_VIRTUAL_METER_UUID': 'Invalid virtual meter uuid',
        'API.INVALID_WEB_MESSAGE_ID': 'Invalid web message id',
        'API.INVALID_WECHAT_MESSAGE_ID': 'Invalid wechat message id',
        'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
        'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
        'API.INVALID_WORKING_CALENDAR_ID': 'Invalid working calendar id ',
        'API.INVALID_WORKING_CALENDAR_NAME': 'Invalid working calendar name',
        'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Knowledge File Cannot be Removed from Disk',
        'API.KNOWLEDGE_FILE_NOT_FOUND': 'Knowledge file not found',
        'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY':
            'Master meter does not belong to same energy category',
        'API.MASTER_METER_NOT_FOUND': 'Master meter not found',
        'API.MENU_NOT_FOUND': 'Menu not found',
        'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
        'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
        'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
        'API.METER_NAME_IS_ALREADY_IN_USE': 'Meter name is already in use',
        'API.METER_NOT_FOUND': 'Meter not found',
        'API.METER_OF_VARIABLE_NOT_FOUND': 'Meter of variable not found',
        'API.METER_POINT_RELATION_EXISTS': 'Meter point relation exists',
        'API.METER_POINT_RELATION_NOT_FOUND': 'Meter point relation not found',
        'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
        'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
        'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
        'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
        'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
        'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
        'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
        'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
        'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
        'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
        'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
        'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
        'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
        'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
        'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
        'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
            'Microgrid power conversion system name is already in use',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
        'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
        'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
        'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
        'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
        'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'New password length cannot exceed 100 characters',
        'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
        'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
        'API.NON_WORKING_DAY_NOT_FOUND': 'Non working day non found',
        'API.NOT_FOUND': 'Not found',
        'API.NOTIFICATION_NOT_FOUND': 'Notification not found',
        'API.OFFLINE_METER_FILE_NOT_FOUND': 'Offline meter file not found',
        'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Offline meter name is already in use',
        'API.OFFLINE_METER_NOT_FOUND': 'Offline meter not found',
        'API.INVALID_OFFLINE_METER_VALUE': 'Valeur de compteur hors ligne invalide',
        'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Offline meter of variable not found',
        'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Old password length cannot exceed 100 characters',
        'API.PARENT_SPACE_NOT_FOUND': 'Parent space not found',
        'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Password length cannot exceed 100 characters',
        'API.PASSWORDS_MATCH': 'New password is the same as the old password',
        'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
        'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
        'API.POINT_NAME_IS_ALREADY_IN_USE': 'Point name is already in use',
        'API.POINT_NOT_FOUND': 'Point not found',
        'API.POWER_POINT_NOT_FOUND': 'Power point not found',
        'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Privilege name is already in use',
        'API.PRIVILEGE_NOT_FOUND': 'Privilege not found',
        'API.RULE_NAME_IS_ALREADY_IN_USE': 'Rule name is already in use',
        'API.RULE_NOT_FOUND': 'Rule not found',
        'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
        'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Sensor name is already in use',
        'API.SENSOR_NOT_FOUND': 'Sensor not found',
        'API.SENSOR_POINT_RELATION_EXISTS': 'Sensor point relation exists',
        'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Sensor point relation not found',
        'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
        'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Shopfloor equipment relation exists',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Shopfloor equipment relation not found',
        'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Shopfloor meter relation exists',
        'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Shopfloor meter relation not found',
        'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Shopfloor name is already in use',
        'API.SHOPFLOOR_NOT_FOUND': 'Shopfloor not found',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Shopfloor offline meter relation exists',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Shopfloor offline meter relation not found',
        'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Shopfloor point relation exists',
        'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Shopfloor point relation not found',
        'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Shopfloor sensor relation exists',
        'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Shopfloor sensor relation not found',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Shopfloor virtual meter relation exists',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Shopfloor virtual meter relation not found',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Shopfloor working calendar relation exists',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Shopfloor working calendar relation not found',
        'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
        'API.SOURCE_NODE_NOT_FOUND': 'Source node not found',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Space combined equipment relation exists',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Space combined equipment relation not found',
        'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
        'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
        'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Space equipment relation exists',
        'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Space equipment relation not found',
        'API.SPACE_METER_RELATION_EXISTS': 'Space meter relation exists',
        'API.SPACE_METER_RELATION_NOT_FOUND': 'Space meter relation not found',
        'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Space name is already in use',
        'API.SPACE_NOT_FOUND': 'Space not found',
        'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Space not found in privilege',
        'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Space offline meter relation exists',
        'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Space offline meter relation not found',
        'API.SPACE_POINT_RELATION_EXISTS': 'Space point relation exists',
        'API.SPACE_POINT_RELATION_NOT_FOUND': 'Space point relation not found',
        'API.SPACE_SENSOR_RELATION_EXISTS': 'Space sensor relation exists',
        'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Space sensor relation not found',
        'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Space shopfloor relation exists',
        'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Space shopfloor relation not found',
        'API.SPACE_STORE_RELATION_EXISTS': 'Space store relation exists',
        'API.SPACE_STORE_RELATION_NOT_FOUND': 'Space store relation not found',
        'API.SPACE_TENANT_RELATION_EXISTS': 'Space tenant relation exists',
        'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Space tenant relation not found',
        'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Space virtual meter relation exists',
        'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Space virtual meter relation not found',
        'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Space working calendar relation exists',
        'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Space working calendar relation not found',
        'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'Start datetime must be early than end datetime',
        'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
        'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
        'API.STORE_METER_RELATION_EXISTS': 'Store meter relation exists',
        'API.STORE_METER_RELATION_NOT_FOUND': 'Store meter relation not found',
        'API.STORE_NAME_IS_ALREADY_IN_USE': 'Store name is already in use',
        'API.STORE_NOT_FOUND': 'Store not found',
        'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Store offline meter relation exists',
        'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Store offline meter relation not found',
        'API.STORE_POINT_RELATION_EXISTS': 'Store point relation exists',
        'API.STORE_POINT_RELATION_NOT_FOUND': 'Store point relation not found',
        'API.STORE_SENSOR_RELATION_EXISTS': 'Store sensor relation exists',
        'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Store sensor relation not found',
        'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Store type name is already in use',
        'API.STORE_TYPE_NOT_FOUND': 'Store type not found',
        'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Store type simplified code is already in use',
        'API.STORE_TYPE_USED_IN_STORE': 'Store type used in store',
        'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Store virtual meter relation exists',
        'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Store virtual meter relation not found',
        'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Store working calendar relation exists',
        'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Store working calendar relation not found',
        'API.TARGET_NODE_NOT_FOUND': 'Target node not found',
        'API.TARIFF_IN_USE': 'Tariff in use',
        'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Tariff is already associated with cost center',
        'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Tariff is not associated with cost center',
        'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Tariff name is already in use',
        'API.TARIFF_NOT_FOUND': 'Tariff not found',
        'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
        'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
        'API.TENANT_METER_RELATION_EXISTS': 'Tenant meter relation exists',
        'API.TENANT_METER_RELATION_NOT_FOUND': 'Tenant meter relation not found',
        'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Tenant name is already in use',
        'API.TENANT_NOT_FOUND': 'Tenant not found',
        'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Tenant offline meter relation exists',
        'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Tenant offline meter relation not found',
        'API.TENANT_POINT_RELATION_EXISTS': 'Tenant point relation exists',
        'API.TENANT_POINT_RELATION_NOT_FOUND': 'Tenant point relation not found',
        'API.TENANT_SENSOR_RELATION_EXISTS': 'Tenant sensor relation exists',
        'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Tenant sensor relation not found',
        'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Tenant type name is already in use',
        'API.TENANT_TYPE_NOT_FOUND': 'Tenant type not found',
        'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Tenant type simplified code is already in use',
        'API.TENANT_TYPE_USED_IN_TENANT': 'Tenant type used in tenant',
        'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Tenant virtual meter relation exists',
        'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Tenant virtual meter relation not found',
        'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Tenant working calendar relation exists',
        'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Tenant working calendar relation not found',
        'API.TEXT_MESSAGE_NOT_FOUND': 'Text message not found',
        'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'The reporting period must be longer than 15 minutes',
        'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'There is relation with child meters',
        'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'There is relation with children spaces',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS':
            'There is relation with combined equipment parameters',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'There is relation with combined equipments',
        'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'There is relation with data sources',
        'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'There is relation with energy flow diagram links',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'There Is Relation With Energy Storage Containers Batteries',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'There Is Relation With Energy Storage Containers Grids',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'There Is Relation With Energy Storage Containers Loads',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'There Is Relation With Energy Storage Containers Power Conversion Systems',
        'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'There is relation with equipment parameters',
        'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'There is relation with equipments',
        'API.THERE_IS_RELATION_WITH_METER': 'There is relation with meter',
        'API.THERE_IS_RELATION_WITH_METERS': 'There is relation with meters',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'There is relation with offline meter',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'There is relation with offline meters',
        'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'There is relation with other virtual meters',
        'API.THERE_IS_RELATION_WITH_SENSORS': 'There is relation with sensors',
        'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'There is relation with shopfloors',
        'API.THERE_IS_RELATION_WITH_SPACES': 'There is relation with spaces',
        'API.THERE_IS_RELATION_WITH_STORES': 'There is relation with stores',
        'API.THERE_IS_RELATION_WITH_TENANTS': 'There is relation with tenants',
        'API.THERE_IS_RELATION_WITH_USERS': 'There is relation with users',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'There is relation with virtual meter',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'Relacionado con centrales virtuales',
        'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'This data source is being used by a meter',
        'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This meter is being used by a virtual meter',
        'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This offline meter is being used by a virtual meter',
        'API.THIS_SPACE_CANNOT_BE_CLONED': 'This space cannot be cloned',
        'API.THIS_SPACE_CANNOT_BE_DELETED': 'This space cannot be deleted',
        'API.TIMEZONE_NOT_FOUND': 'Timezone not found',
        'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token not found in headers please login',
        'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'User Account Has Been Locked',
        'API.USER_ACCOUNT_HAS_EXPIRED': 'User Account Has Expired',
        'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
        'API.USER_NAME_IS_ALREADY_IN_USE': 'User name is already in use',
        'API.USER_NOT_FOUND': 'User not found',
        'API.USER_PASSWORD_HAS_EXPIRED': 'User Password Has Expired',
        'API.USER_PRIVILEGE_NOT_FOUND': 'User privilege not found',
        'API.USER_SESSION_NOT_FOUND': 'User session not found',
        'API.USER_SESSION_TIMEOUT': 'User session timeout',
        'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'User uuid not found in headers please login',
        'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Virtual meter name is already in use',
        'API.VIRTUAL_METER_NOT_FOUND': 'Virtual meter not found',
        'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Virtual meter of variable not found',
        'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Virtual point should be analog value',
        'API.WEB_MESSAGE_NOT_FOUND': 'Web message not found',
        'API.WECHAT_MESSAGE_NOT_FOUND': 'Wechat message not found',
        'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
        'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
        'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Working calendar name is already in use',
        'API.WORKING_CALENDAR_NOT_FOUND': 'Working calendar not found',

        MasterMeter: 'Tabla general',
        SubMeter: 'Tabla dividida',
        'Power Quality': 'Качество электроэнергии',
        'About Power Quality': 'О качестве электроэнергии',
        'Trend Values': 'Значения тренда',
        Category: 'Категория',
        Type: 'Тип',
        Unit: 'Единица',
        Limit: 'Предел',
        'Normal Limit': 'Нормальный предел',
        'Severe Limit': 'Критический предел',
        Compliance: 'Уровень соответствия',
        'Worst Deviation': 'Наибольшее отклонение',
        'Worst Time': 'Время наибольшего отклонения',
        'Severe Exceed Count': 'Число серьёзных превышений',
        'Worst Unbalance': 'Максимальный небаланс',
        Hz: 'Гц',
        voltage: 'Напряжение',
        current: 'Ток',
        frequency: 'Частота',
        voltage_deviation: 'Отклонение напряжения',
        current_unbalance: 'Несимметрия тока',
        voltage_unbalance: 'Несимметрия напряжения',
        mean_deviation_pct: 'Среднее отклонение (%)',
        p95_abs_deviation_pct: 'P95 абсолютное отклонение (%)',
        mean_abs_deviation_hz: 'Среднее абсолютное отклонение (Гц)',
        frequency_deviation: 'Отклонение частоты',
        p95_abs_deviation_hz: 'P95 абсолютное отклонение (Гц)',
        mean_unbalance_pct: 'Средняя несимметрия (%)',
        p95_unbalance_pct: 'P95 несимметрия (%)',
        count: 'Количество',
        min: 'Мин',
        max: 'Макс',
        mean: 'Среднее',
        std: 'Ст. откл.',
        p5: 'P5',
        p95: 'P95'
    }
};
